import React from 'react';
import { useState } from 'react';
import { getEnvName } from './util';

import './UpdateApplicationsStyles.css';

function UpdateApplications(props) {

    var environmentStr = getEnvName();

    const datacenters = props.datacenters;
    const [values, setValues] = useState({
        name: '', datacenter: '', applicationToUpdate: '', secretKey: ''
    });

    const set = name => {
        return ({ target: { value } }) => {
        setValues(oldValues => ({...oldValues, [name]: value }));
        }
    };

    // empty array for logs
    const postLogs = [];

    // make post logs array reactive
    const [postErrorLogs, setPostLogs] = useState(postLogs);

    function httpPost(theUrl, theBody)  {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var raw = JSON.stringify(theBody);
    
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
    
        fetch(theUrl, requestOptions)
          .then(response => response.text())
          .then(result => {
            if (!result.includes("processing application update")) {
              // add error to on screen logs
              setPostLogs(oldArray => [...oldArray, theUrl + "\n" + String(result)].sort((a, b) =>
              a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })))
            } else {
              console.log(result)
            }
          })
          .catch(error => setPostLogs(oldArray => [...oldArray, theUrl + "\n" + String(error)].sort((a, b) =>
          a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))));
    }

    function pathValidator(dc, path, application) {

      console.log(dc + path + application)

      // takes filename from path
      let fullFileName = path.split("/").pop();
      let fileNameStart = fullFileName.split("-").shift();

      console.log(fileNameStart)

      if (application === "vmagent") {

        // filename does not start with vmagent return false
        if (fileNameStart != "vmagent"){
          return false;
        }

        return path.includes("vmagent/") && path.endsWith(".jar") ? true : false;

      } else if (application === "3dapp") {

        // filename does not start with InvictusVehicleConfigurator return false
        if (fileNameStart != "InvictusVehicleConfigurator"){
          return false;
        }

        // path same for prod, dev, qa and test
        return path.includes("3dAppBuilds/") && path.endsWith(".zip") ? true : false;

      } else {

        return false;

      }
    }

    const onSubmit = async (event) => {

        // clear old logs after new submit
        setPostLogs([]);
    
        event.preventDefault();

        // if path is valid run updates as normal
        if (pathValidator(values.datacenter, values.name, values.applicationToUpdate)) {
          try {
            console.log("running update calls async...")
            await runUpdateCalls();
            alert('Updates Running...');
            setValues({
              name: '', datacenter: ''
            });
          } catch (e) {
            alert(`Update failed! ${e.message}`);
          }
        } else {
          alert('Invalid path')
        }
    }

    function runUpdateCalls() {
        try{

          if (values.applicationToUpdate === "vmagent") {

            // set of vmAgents that will be updated
            let vmAgentUpdateSet = new Set();
            // from each unreal application.. ensure we collect all vmagents to update
            props.UpdateApplications.forEach(currMachine => {
              if(values.datacenter === currMachine.datacenter){
                vmAgentUpdateSet.add(currMachine.hostName + "/updateApplication")
              }
            });

            // calculate POST body
            var jsonBody = {};
            jsonBody.applicationToUpdate = "vmagent"
            jsonBody.filenameInS3 = values.name
            jsonBody.secretKey = values.secretKey

            // make update call to each vmAgent
            vmAgentUpdateSet.forEach(vmAgentUpdateEndpoint => {
              // complete updates
              httpPost(vmAgentUpdateEndpoint, jsonBody)
            });

          } else if (values.applicationToUpdate === "3dapp") {

            console.log(values.datacenter + values.applicationToUpdate + values.name)
            // set of vmAgents that will be updated
            let vmAgentUpdateSet = new Set();
            // from each unreal application.. ensure we collect all vmagents to update
            props.UpdateApplications.forEach(currMachine => {
              if(values.datacenter === currMachine.datacenter){
                vmAgentUpdateSet.add(currMachine.hostName + "/updateApplication")
              }
            });
      
            // calculate POST body
            var jsonBody = {};
            jsonBody.filenameInS3 = values.name
            jsonBody.applicationToUpdate = "3dapp"
            jsonBody.secretKey = values.secretKey
      
            // make update call to each vmAgent
            vmAgentUpdateSet.forEach(vmAgentUpdateEndpoint => {
              // complete updates
              httpPost(vmAgentUpdateEndpoint, jsonBody)
            });
          }
    
        }catch(e){
          console.log(e)
        }
      }

  return (
    <form onSubmit={onSubmit}>
      <h2>Update Application</h2>
      <div>
        <label>Application filename (includes path)*: </label>
        <input type="text" required value={values.name} onChange={set('name')} />
      </div>

      <div>
        <label>Secret Key: </label>
        <input type="password" required value={values.secretKey} onChange={set('secretKey')} />
      </div>

      <div>
      <label>Application</label>
        <select name="applicationToUpdate" onChange={set('applicationToUpdate')}>
            <option value="" disabled selected hidden>Select</option>
            <option value="vmagent">vmagent</option>
            <option value="3dapp">3dapp</option>
        </select>
      </div>

      <div>
      <label>Datacenter*:</label>
        <select required value={values.datacenter} onChange={set('datacenter')}>
          <option value="">Select</option>
          {datacenters.map(c => <option key={c}>{c}</option>)}
        </select>
      </div>

      <div>
        <button type="submit">Submit</button>
      </div>

      <input id="collapsible" className="toggle" type="checkbox"></input>
      <label htmlFor="collapsible" className="lbl-toggle">Post Logs</label>
      <div className="collapsible-content">
        <div className="content-inner">
          <ul id="postData">
            {postErrorLogs.map(log => <li id="postLog" key={log}>{log}</li>)}
          </ul>
        </div>
      </div>
    </form>
  );
}

export default UpdateApplications;
